module.exports = __webpack_public_path__ + "static/media/climate.b580de4e.png";